import { CBCC_USER_FLOW } from '../cbcc/types';

// The bank can describe the completed/no-management-redirect state in two ways:
// the canonical APPROVED + NO_REDIRECTION pair, or the legacy
// ONBOARDING_COMPLETE + NO_REDIRECTION pair. Both represent the same approved
// experience. In this state the Manage Card CTA is suppressed everywhere (hero
// / sticky header / mobile bar) and the approval-confirmation card — the CVP
// ineligibleLogo/Text/SubText fields — shows as the second screen instead (see
// ApprovedInfoSection + ManageCardPage). Structural params keep these helpers
// decoupled from the response/fixture types.
type ApprovalData = { status?: string; userFlow?: string };
type ApprovalState = ApprovalData | undefined;

export function isApprovedNoRedirection(data: ApprovalState): boolean {
	return (
		(data?.status === 'APPROVED' || data?.status === 'ONBOARDING_COMPLETE') &&
		data?.userFlow === CBCC_USER_FLOW.NO_REDIRECTION
	);
}

/** Whether the landing route should render the approved/manage-card experience. */
export function isApprovedExperience(data: ApprovalState): boolean {
	return data?.status === 'APPROVED' || isApprovedNoRedirection(data);
}
